export const operationMissions = `
  mutation RegisterLastLogin($userId: Int!) {
    registerLastLogin(payload: {userId: $userId}) {
      missionCompleted
      success
    }
  }
`